<template>
  <div class="second-container">
    <AdminLeft/>
    <div class="column-con">
      <AdminTop/>
      <div class="column-con">
        <div class="cell-pas">
          <span class="cell-span">原始密码: </span>
          <el-input v-model="queryData.oldPassword" placeholder="请输入原始密码" type="password"></el-input>
        </div>
        <div class="cell-pas">
          <span class="cell-span">新密码: </span>
          <el-input v-model="queryData.newPassword" placeholder="请输入新密码" type="password"></el-input>
        </div>
        <div class="cell-pas">
          <span class="cell-span">再次确认密码: </span>
          <el-input v-model="queryData.confirmPassword" placeholder="请确认密码" type="password"></el-input>
        </div>
        <el-button type="primary" size="large" style="margin-left: 140px;margin-top: 30px;" @click="_handleChange">
          确认修改
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import AdminLeft from "@/components/AdminLeft";
import AdminTop from "@/components/AdminTop";
import {ElMessage} from "element-plus";
import http from "@/util/http";

export default {
  name: "AdminPassword",
  components: {
    AdminLeft,
    AdminTop
  },
  data() {
    return {
      queryData: {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      }
    }
  },
  methods: {
    _handleChange() {
      if (!this.queryData.oldPassword) {
        ElMessage.error("原始密码不能为空")
        return
      }
      if (!this.queryData.newPassword) {
        ElMessage.error("新密码不能为空")
        return
      }
      if (!this.queryData.confirmPassword) {
        ElMessage.error("确认密码不能为空")
        return
      }

      http.post('changePassword', {
        passWordNew: this.queryData.newPassword,
        passWord: this.queryData.oldPassword
      })
          .then((res) => {
            if (res.data.status === 0) {
              this.queryData.confirmPassword = undefined
              this.queryData.newPassword = undefined
              this.queryData.oldPassword = undefined
              ElMessage.success(res.data.content)
            } else {
              ElMessage.error(res.data.content)
            }
          })
    }
  }
}
</script>

<style scoped>

.column-con {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
}

.cell-span {
  width: 200px;
  text-align: end;
  margin-right: 20px;
}

.cell-pas {
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  min-width: 300px;
}
</style>